<template>
  <div>
    <div class="error-wrapper">
      <div class="error-message">
        <h2>Whoops</h2>
        <p>Something went wrong. The page you are trying to find is no longer here.</p>
        <router-link :to="{path: '/' }">To start page ›</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped>
.error-wrapper {
  width: 100%;
  margin-top: 220px;
  background-image: url(https://cdn2.hubspot.net/hubfs/515431/nuiteq.com/Images/may-2016/404-bg.png);
  background-repeat: no-repeat;
  padding: 100px 0px 400px 400px;
  background-position: 60% 70%;
  min-height: 350px;
}
.error-message {
  position: absolute;
  left: 23%;
  max-width: 280px;
  top: 100px;
}

p {
  color: #333;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.375em;
}

h2 {
  color: #333;
  font-size: 80px;
  font-weight: 600;
  line-height: normal;
  margin-top: 50px;
  margin-bottom: 0px;
  font-family: "Montserrat", sans-serif;
}
@media (max-width: 1224px) {
  .error-wrapper {
    background-repeat: no-repeat;
    background-size: 80%;
    padding: 80px 50px 100px 50px;
    background-position: 85% 78%;
    margin-right: 0px;
  }
  .error-message {
    position: absolute;
    left: 10px;
    max-width: 280px;
    top: 20px;
  }
}

@media (min-width: 791px) and (max-width: 1224px) {
  .error-wrapper {
    margin-top: 100px;
    min-height: 480px;
  }
}
</style>
